export default {
    init() {
        const faqs = document.querySelectorAll('.schema-faq-component');
        if (faqs && faqs.length) {
            faqs.forEach((faq) => {
                faq.addEventListener('click', e => this.toggleClass(e));
            });
        }
    },

    toggleClass({ currentTarget }) {
        const faqs = document.querySelectorAll('.schema-faq-component.active');
        if (faqs && faqs.length) {
            faqs.forEach((faq) => {
                faq.classList.remove('active');
            });
        }
        currentTarget.classList.add('active');
    },
};
